import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import SrcsetImage from './SrcsetImage';

const styles = css`
  width: 100%;
  display: none;
  z-index: 0;
  position: relative;
  @media (min-width: 768px) {
    display: block;
  }
  .ContactBanner_wrapper {
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column-reverse;
    @media (min-width: 768px) {
      display: block;
      position: relative;
      z-index: 1;
      padding: 0 46px;
    }
    @media (min-width: 992px) {
      padding: 0 60px;
    }
  }
  .ContactBanner_backgroundImageWrapper {
    position: relative;
    width: 100%;
    height: 200px;
    overflow: hidden;
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      background-color: rgba(0,0,0,0.71);
    }
    @media (min-width: 768px) {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
    }
  }
  .ContactBanner_backgroundImage {
    position: absolute;
    top: -100%;
    right: -100%;
    bottom: -100%;
    left: -100%;
    min-width: 100%;
    min-height: 100%;
    margin: auto;
    @supports (object-fit: cover) and (object-position: center center) {
      position: static;
      min-width: 0;
      min-height: 0;
      margin: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center center;
    }
  }
  .ContactBanner_info {
    display: block;
    position: relative;
    text-align: center;
    width: 100%;
    z-index: 2;
    padding: 43px 34px 58px;
    background-color: #1A1A17;
    @media (max-width: 359.98px) {
      padding-left: 28px;
      padding-right: 28px;
    }
    @media (min-width: 768px) {
      padding: 68px 0 92px;
      background-color: transparent;
    }
    @media (min-width: 992px) {
      padding: 82px 0 111px;
      max-width: 1140px;
      margin: 0 auto;
    }
  }
  .ContactBanner_title {
    font-size: 30px;
    font-weight: 200;
    line-height: 1.181818;
    letter-spacing: 0.161636em;
    text-transform: uppercase;
    margin-bottom: 0.272727em;
    color: #FFFFFF;
    @media (min-width: 360px) {
      font-size: 32px;
    }
    @media (min-width: 375px) {
      font-size: 35px;
    }
    @media (min-width: 768px) {
      font-size: 45px;
    }
    @media (min-width: 992px) {
      font-size: 55px;
    }
  }
  .ContactBanner_text {
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.027826em;
    line-height: 1.217391;
    color: #CDAB35;
    margin: 0;
    @media (min-width: 768px) {
      font-size: 18px;
    }
    @media (min-width: 992px) {
      font-size: 21px;
    }
  }
  &.ContactBanner-submitted {
    .ContactBanner_info {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 200px;
      @media (min-width: 768px) {
        min-height: 320px;
      }
      @media (min-width: 992px) {
        min-height: 400px;
      }
    }
  }
`;


class ContactBanner extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      formSubmitted: false,
    };
  }

  render() {
    const { widget } = this.props;
    const { formSubmitted } = this.state;

    return (
      <div className={`${styles} ${formSubmitted ? 'ContactBanner-submitted' : ''}`.trim()}>
        <div className="ContactBanner_wrapper">
          <div className="ContactBanner_backgroundImageWrapper">
            <SrcsetImage
              className="ContactBanner_backgroundImage"
              src={get(widget, 'image.contentUrl')}
              alt=""
            />
          </div>
        </div>
      </div>
    );
  }
}

ContactBanner.propTypes = {
  widget: PropTypes.object.isRequired,
};

ContactBanner.defaultProps = {
  formName: undefined,
  formLabel: undefined,
};

export default withData({
  widget: 'contact_banner',
  builder: true,
})(ContactBanner);



// WEBPACK FOOTER //
// ./src/components/ContactBanner.js